const firebaseConfig = {
    apiKey: "AIzaSyBA3yWsE2ZzRlFMdGLdmnBKdyQ3B87mKns",
    authDomain: "react-auth-mahesajib.firebaseapp.com",
    projectId: "react-auth-mahesajib",
    storageBucket: "react-auth-mahesajib.appspot.com",
    messagingSenderId: "757335500740",
    appId: "1:757335500740:web:252b2c9e84b9250947e691"
  };
  export default firebaseConfig;